__turbopack_export_value__({
  "videoContainer": "DynamicVideoEmbed-module-scss-module__38ckLq__videoContainer",
});
